<div class="quote-conversion-container">
    <div class="quote-conversion-content">
        @if (appFacadeService.getQuoteConversionInProgress() | async) {
        <por-busy-indicator [message]="'PleaseWaitWhileWeProcessYourQuoteConversion' | translate"></por-busy-indicator>
        } @else {
        <div class="error-message">
            <h2>{{ 'QuoteConversionFailed' | translate }}</h2>
            <p>{{ 'UnableToConvertQuoteToReservation' | translate : { storeName: (appFacadeService.getConfig() | async)?.storeName } }}</p>
            <button (click)="onCloseClick()" class="close-button btn btn-primary">{{ 'Close' | translate }}</button>
        </div>
        }
    </div>
</div>
